document.addEventListener("DOMContentLoaded", () => {

    const boton = document.getElementById("consultar-imei");
    const input = document.getElementById("imei");
    const resultado = document.getElementById("resultado-imei");

    if (!boton || !input || !resultado) return;

    boton.addEventListener("click", async () => {

        const imei = input.value.trim();

        if (imei.length !== 15) {
            resultado.innerHTML = "Ingrese un IMEI válido.";
            return;
        }

        resultado.innerHTML = "Consultando...";

        try {

            const response = await fetch(
                "https://sucursalmiwom.wom.cl/listablanca/api/whitelist/consultaImeiInfo/v2",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        linea: "",
                        imei: imei,
                        token: ""
                    })
                }
            );

            const data = await response.json();

            console.log(data);

            if (data.Resultado && data.Resultado.length > 0) {

                const estado = data.Resultado[0].ESTADO;
                const mensaje = data.Resultado[0].mensajeSubtel;

                resultado.innerHTML = `
                    <h3>${estado}</h3>
                    <p>${mensaje}</p>
                `;

            } else {

                resultado.innerHTML = "No hubo resultados.";

            }

        } catch (error) {

            console.error(error);

            resultado.innerHTML = "Error consultando la API.";

        }

    });

});